import axios from '@/plugins/axios'
import { useAppStore } from '@/stores/app'
import type IDataResponse from '@/interfaces/api-resources/DataResponse'
import type IGroupSimple from '@/interfaces/api-resources/Dara/GroupSimple'
import type IDataAdditionalResponse from '@/interfaces/api-resources/DataAdditionalResponse'

interface GroupDeleteResponse {
  last_yeargroup_deleted: boolean;
  last_subgroup_deleted: boolean;
  require_year_selection: boolean;
  require_subgroup_selection: boolean;
}

interface GroupGetAdditionalResponse {
  students_without_group_count: number
}

export default {
  baseUrl() {
    const appStore = useAppStore()

    return `${appStore.daraApiBaseUrl}`
  },

  getByAcademicYear(academicYearId: number) {
    return axios.get<IDataAdditionalResponse<IGroupSimple[], GroupGetAdditionalResponse>, IDataAdditionalResponse<IGroupSimple[], GroupGetAdditionalResponse>>(`${ this.baseUrl() }/organisation-academic-years/${ academicYearId }/groups`)
      .catch(() => {
        throw new Error('Failed to fetch groups')
      })
  },

  createGroup(academicYearId: number, data: object) {
    return axios.post(`${this.baseUrl()}/organisation-academic-years/${academicYearId}/groups`, data)
  },

  createSubGroup(groupId: number, data: object) {
    return axios.post(`${this.baseUrl()}/groups/${groupId}/subdivisions`, data)
  },

  deleteGroup(groupId: number) {
    return axios.delete<GroupDeleteResponse, GroupDeleteResponse>(`${this.baseUrl()}/groups/${groupId}`)
  },

  updateGroup(groupId: number, data: object) {
    return axios.put(`${this.baseUrl()}/groups/${groupId}`, data)
  },

  reorderGroups(academicYearId: number, data: object) {
    return axios.post(`${this.baseUrl()}/organisation-academic-years/${academicYearId}/groups/order`, data)
  },

  copyGroups(academicYearId: number, data: object) {
    return axios.post(`${this.baseUrl()}/organisation-academic-years/${academicYearId}/copy-previous-groups`, data)
  },

  moveStudents(academicYearId: number, data: object) {
    return axios.post(`${this.baseUrl()}/organisation-academic-years/${academicYearId}/move-previous-students`, data)
  },

  students(groupId: number) {
    return axios.get<
      IDataResponse<Domain.Students.Resources.ApiV3.StudentNameResource[]>,
      IDataResponse<Domain.Students.Resources.ApiV3.StudentNameResource[]>
    >(`${this.baseUrl()}/groups/${groupId}/students`)
  },
}
